import { render } from "./AppRichTextEditor.vue?vue&type=template&id=1683e02c&ts=true"
import script from "./AppRichTextEditor.vue?vue&type=script&lang=ts"
export * from "./AppRichTextEditor.vue?vue&type=script&lang=ts"

import "./AppRichTextEditor.vue?vue&type=style&index=0&id=1683e02c&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__